// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { ADD_APPLICATION_SETTINGS } from './types'

export const addApplicationSettings = entity => ({
  type: ADD_APPLICATION_SETTINGS,
  entity,
})
